import axios from 'axios';

import routes from 'app/routes';

export default {
  getToken: (dispatch) => {
    axios
      .post(routes.api.users.tokens.create)
      .then((response) => {
        dispatch({ type: 'GET_TOKEN', token: response.data.data.token });
      });
  },

  load: (dispatch, token) => {
    axios
      .get(`${gon.ai_rest_api_base_url}/v1/chat/list`, {
        headers: {
          Authorization: `${token}`,
        },
      })
      .then((resp) => {
        dispatch({ type: 'LOAD', chats: resp.data.chats });
      });
  },

  loadAvatar: (dispatch) => {
    axios
      .get(routes.api.users.avatar)
      .then((resp) => {
        dispatch({
          type: 'LOAD_AVATAR',
          avatar: resp.data.data,
        });
      });
  },

  setCurrentChatId: (dispatch, chatId) => {
    dispatch({ type: 'SET_CURRENT_CHAT_ID', chatId });
  },

  updateChatTitle: (dispatch, chatId, title) => {
    dispatch({ type: 'SET_CHAT_TITLE', chatId, title });
  },

  generateChatTitle: (dispatch, token, chatId) => {
    axios
      .post(
        `${gon.ai_rest_api_base_url}/v1/chat/${chatId}/title`,
        {},
        {
          headers: {
            Authorization: `${token}`,
          },
        },
      )
      .then((resp) => {
        const chat = resp.data;
        console.log(chat);
        dispatch({ type: 'SET_CHAT_TITLE', chatId, title: chat.title });
      });
  },

  loadChat: (dispatch, token, chatId) => {
    axios
      .get(
        `${gon.ai_rest_api_base_url}/v1/chat/${chatId}`,
        {
          headers: {
            Authorization: `${token}`,
          },
        },
      )
      .then((resp) => {
        dispatch({ type: 'LOAD_CHAT', chat: resp.data });
      });
  },

  createChat: ({
    token, sessionType, avatarId, avatarName, bedrockAvatarId, bedrockAvatarAliasId, callback,
  }) => {
    axios
      .post(`${gon.ai_rest_api_base_url}/v1/chat/start`, {
        avatar_id: avatarId,
        avatar_name: avatarName,
        session_type: sessionType,
        bedrock_avatar_id: bedrockAvatarId,
        bedrock_avatar_alias_id: bedrockAvatarAliasId,
      }, {
        headers: {
          Authorization: `${token}`,
        },
      })
      .then((response) => {
        callback(response.data.session_id);
      });
  },

  deleteChat: (dispatch, token, chatId) => {
    axios
      .delete(`${gon.ai_rest_api_base_url}/v1/chat/${chatId}`, {
        headers: {
          Authorization: `${token}`,
        },
      })
      .then((_resp) => {
        dispatch({ type: 'DELETE_CHAT', chatId });
      });
  },

  setNewChat: (dispatch) => {
    dispatch({ type: 'NEW_CHAT' });
  },

  setNewChatAfterDelete: (dispatch) => {
    dispatch({ type: 'NEW_CHAT_AFTER_DELETE' });
  },

  skipAiSessionDescriptionPopup: (dispatch) => {
    axios
      .post(routes.api.users.skipAiSessionDescriptionPopup)
      .then((resp) => {
        dispatch({
          type: 'LOAD_AVATAR',
          avatar: resp.data.data,
        });
      });
  },

  saveFeedback: (chatId, token, params, callback) => {
    axios
      .post(
        `${gon.ai_rest_api_base_url}/v1/chat/${chatId}/feedback`,
        {
          feedback: params.comment,
          rate: params.rate,
        },
        {
          headers: {
            Authorization: `${token}`,
          },
        },
      )
      .then((_resp) => {
        callback();
      });
  },

};
